import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFilterStore } from "@faire/retailer-visitor-shared/components/Filters/useFilterStore";
import { withBanner } from "@faire/retailer-visitor-shared/lib/bannerUtils";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import isChromatic from "chromatic/isChromatic";
import React, { useMemo } from "react";
import styled from "styled-components";
import { useLoggedOutCategoryPageBannersResponse } from "@faire/retailer/components/Banners/DataFetching/useLoggedOutCategoryPageBannersResponse";
import { LoggedOutCategoryBanners } from "@faire/retailer/components/Banners/LoggedOutCategoryBanners/LoggedOutCategoryBanners";
import { EfficientListLoader } from "@faire/retailer/components/EfficientListLoader/EfficientListLoader";
import { withFallback } from "@faire/retailer/components/GhostLoading/helpers";
export var LoggedOutCategoryPageItemList = function(props) {
    var isSSR = useIsSSR();
    var items = props.items, renderItem = props.renderItem, onBatchVisible = props.onBatchVisible, _props_batchFallbackSize = props.batchFallbackSize, batchFallbackSize = _props_batchFallbackSize === void 0 ? 20 : _props_batchFallbackSize;
    var _useFilterStore = useFilterStore([
        "isSideBarVisible"
    ]), isSideBarVisible = _useFilterStore.data.isSideBarVisible;
    var itemsPerRowWithFilterOpen = useResponsiveValue({
        mobileAndAbove: 2,
        tabletAndAbove: 4
    });
    var itemsPerRowWithFilterClosed = useResponsiveValue({
        mobileAndAbove: 2,
        tabletAndAbove: 4,
        desktopAndAbove: 5,
        xLargeAndAbove: 6
    });
    var itemsPerRow = isSideBarVisible ? itemsPerRowWithFilterOpen : itemsPerRowWithFilterClosed;
    var renderProductTileBatchPlaceholder = function(placeholderItems) {
        var _placeholderItems_map;
        return /*#__PURE__*/ _jsx(React.Fragment, {
            children: (_placeholderItems_map = placeholderItems === null || placeholderItems === void 0 ? void 0 : placeholderItems.map(function(_, index) {
                return /*#__PURE__*/ _jsx(SingleProductPlaceholder, {}, "placeholder-".concat(index));
            })) !== null && _placeholderItems_map !== void 0 ? _placeholderItems_map : null
        });
    };
    var displayableBannersWithAdjustedRow = useLoggedOutCategoryPageBannersResponse().displayableBannersWithAdjustedRow;
    var displayableBanners = useMemo(function() {
        return displayableBannersWithAdjustedRow(itemsPerRow, items.length);
    }, [
        displayableBannersWithAdjustedRow,
        itemsPerRow,
        items.length
    ]);
    var data = useMemo(function() {
        if (items.length) {
            if (displayableBanners.length) {
                var itemsToReturn = withBanner(items, itemsPerRow, displayableBanners);
                return itemsToReturn;
            }
            return items;
        }
        return withFallback(items, batchFallbackSize);
    }, [
        displayableBanners,
        items,
        itemsPerRow,
        batchFallbackSize
    ]);
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $columns: itemsPerRow,
        children: [
            /*#__PURE__*/ _jsx(EfficientListLoader, {
                hashKey: props.hashKey,
                data: data,
                batchSize: itemsPerRow * 2,
                renderComponent: renderItem,
                // Remember to update the placeholder if the tile changes
                placeholderFn: renderProductTileBatchPlaceholder,
                forceRender: isSSR || isChromatic(),
                threshold: -400,
                filterFakeTile: true,
                onBatchVisible: onBatchVisible,
                visibilityWrapperDisplayProperty: "unset"
            }),
            /*#__PURE__*/ _jsx(LoggedOutCategoryBanners, {
                banners: displayableBanners
            })
        ]
    });
};
var Wrapper = styled.div.withConfig({
    componentId: "sc-f856708d-0"
})([
    "display:grid;align-self:stretch;gap:",
    ";grid-template-columns:[start] repeat(",
    ",minmax(0,1fr)) [end];"
], getSpacing("3x", "1x"), function(props) {
    return props.$columns;
});
var SingleProductPlaceholder = styled.div.withConfig({
    componentId: "sc-f856708d-1"
})([
    "width:100%;",
    "{height:334px;}",
    "{height:338px;}",
    "{height:360px;}",
    "{height:454px;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tablet, responsiveMediaQueries.desktop, responsiveMediaQueries.xLargeAndAbove);
